import { ProfileService } from "../services/ProfileService";
import { InteractionStatus, IPublicClientApplication } from "@azure/msal-browser";


export const useProfileAvatarData = async (inProgress: InteractionStatus, instance: IPublicClientApplication) => {

  const profileService = new ProfileService();

  if (inProgress === InteractionStatus.None) {
    return await profileService.getProfileAvatarData(instance);
  }

}
